import React from 'react';
import PropTypes from 'prop-types';

const Card = ({ children, className }) => {
  return (
    <div className={`card ${className ? className : ''}`}>
      {children}
    </div>
  )
}

Card.defaultProps = {
  children: null,
  className: null
}

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

Card.Header = ({ children, className }) => {
  return (
    <div className={`header ${className ? className : ''}`}>
      {children}
    </div>
  )
}

Card.Header.defaultProps = {
  children: null,
  className: null
}

Card.Header.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

Card.Body = ({ children }) => {
  return (
    <div>
      {children}
    </div>
  )
}

Card.Body.defaultProps = {
  children: null
}

Card.Body.propTypes = {
  children: PropTypes.node
}


export default Card